export default __webpack_public_path__ + "static/media/MANA.389f86fe.png";